/* @flow */

// this probably makes sense here because we always load nut?
// https://v6.vite.dev/guide/backend-integration.html
// vite tells us to include this
// $FlowIgnore
import 'vite/modulepreload-polyfill'; // eslint-disable-line import/no-unresolved

import './polyfills'; // We want this to run before our babel polyfill
import '@babel/polyfill';
import 'cross-fetch/polyfill';

// Global imports used primarily in legacy code
import React from 'react';
import ReactDOM from 'react-dom';
import {Quill} from 'react-quill';
import 'favico.js';

import Backbone from 'backbone';
import moment from 'moment';
import numeral from 'numeral';
import {Collections} from 'nutshell-core/collections';
// replaces webpack expose-loader
import underscore from 'underscore';
import * as Visibility from 'visibilityjs';

import * as keys from 'shells/utils/keys';

// sidestep recursive css modules problem for now
import './ui/assets/css/shared/custom-properties.css';
import './ui/assets/css/shared/shepherd.css';
import 'setimmediate';

import * as Phone from './phone';
import {pollForNotifications} from './poll-for-notifications';
import {store} from './store';
import * as ui from './ui/ui';
import {writeLocalStorage, readLocalStorage} from './util/localStorage';

window.React = React;
window.ReactDOM = ReactDOM;
window.Visibility = Visibility;

window.Quill = Quill;
window.moment = moment;
window.underscore = underscore;
Backbone.$ = window.jQuery;
window.numeral = numeral;

const {requestCollection, updateCollection} = Collections;

window.Nut = {
    isWebClient: true,
    actions: {
        requestCollection,
        updateCollection,
    },
    dispatch: store.dispatch.bind(store),
    keys,
    Phone,
    ui,
    writeLocalStorage,
    readLocalStorage,
    pollForNotifications,
};
